import { create } from 'zustand';

interface ChallengeState {
  challengeToken: string | null;
  email: string | null;
  setChallenge(challengeToken: string, email: string): void;
  clearChallenge(): void;
}

// Mémoire seule (pas de persistance) : le challenge vit 5 min côté serveur, un rechargement renvoie au login
export const useChallenge = create<ChallengeState>((set) => ({
  challengeToken: null,
  email: null,
  setChallenge: (challengeToken, email) => set({ challengeToken, email }),
  clearChallenge: () => set({ challengeToken: null, email: null }),
}));
